<div
  class="list-item-container"
  role="listitem"
  [attr.tabindex]="tabIndex"
  [attr.aria-disabled]="disabled"
  [attr.aria-selected]="ariaSelected"
  (click)="handleClick($event)"
  (keydown)="handleKeydown($event)"
>
  <div class="list-item-leading" *ngIf="leadingTemplate">
    <ng-container *ngTemplateOutlet="leadingTemplate"></ng-container>
  </div>

  <div class="list-item-content">
    <div class="list-item-title">
      <ng-content></ng-content>
    </div>

    <div class="list-item-subtitle" *ngIf="subtitleTemplate">
      <ng-container *ngTemplateOutlet="subtitleTemplate"></ng-container>
    </div>

    <div class="list-item-meta" *ngIf="metaTemplate">
      <ng-container *ngTemplateOutlet="metaTemplate"></ng-container>
    </div>
  </div>

  <div class="list-item-trailing" *ngIf="trailingTemplate">
    <ng-container *ngTemplateOutlet="trailingTemplate"></ng-container>
  </div>
</div>
